/**
 * MWS Portal Services
 * REST Services der Portal-Anwendung MWS
 *
 * The version of the OpenAPI document: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Description { 
    descr?: string;
    sdescr?: string;
    variant?: Description.VariantEnum;
}
export namespace Description {
    export type VariantEnum = 'de_DE' | 'de_AT' | 'de_CH' | 'fr_FR' | 'fr_CA' | 'en_GB' | 'en_US' | 'it_IT';
    export const VariantEnum = {
        DeDe: 'de_DE' as VariantEnum,
        DeAt: 'de_AT' as VariantEnum,
        DeCh: 'de_CH' as VariantEnum,
        FrFr: 'fr_FR' as VariantEnum,
        FrCa: 'fr_CA' as VariantEnum,
        EnGb: 'en_GB' as VariantEnum,
        EnUs: 'en_US' as VariantEnum,
        ItIt: 'it_IT' as VariantEnum
    };
}


